/* Dollpins · página «Pines personalizados»: acabados con zoom, combinador y formulario de cotización.
   El formulario usa el formulario de contacto de Shopify (POST a /contact): no toca el pago ni el checkout. */
(function () {
  var root = document.querySelector('[data-dp-pz]');
  if (!root) return;
  var cfg;
  try { cfg = JSON.parse(root.querySelector('[data-dp-pz-cfg]').textContent); } catch (e) { return; }
  var IM = cfg.imgs || {};

  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return [].slice.call((ctx || root).querySelectorAll(sel)); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  /* ---------- acabados ---------- */
  var T = [
    { k: 'espejo', name: 'Efecto espejo', short: 'efecto espejo', form: 'Efecto espejo', tint: '#EEF1F5', title: 'Brilla como un espejo', desc: 'Zonas de metal pulido que reflejan la luz. Elegante, sobrio y perfecto para siluetas y logos.', tags: ['Metal pulido', 'Reflejo real', 'Ideal para logos'], imgs: [1, 2, 3, 4], anim: 'pzCut 6s ease-in-out infinite', fx: 'linear-gradient(110deg,transparent 35%,rgba(255,255,255,.95) 48%,transparent 60%)', fxAnim: 'pzShine 3.2s ease-in-out infinite', fxOp: 1 },
    { k: 'troqb', name: 'Troquelados', short: 'troquelado', form: 'Troquelado', tint: '#E4F6F0', title: 'Cortados a la forma exacta', desc: 'El pin sigue el contorno de tu diseño, con huecos y bordes únicos. Tu marca, sin cuadrados ni círculos de relleno.', tags: ['Forma libre', 'Huecos calados', 'Bordes únicos'], imgs: [1, 2, 3, 4], anim: 'pzCut 5s ease-in-out infinite', fx: 'none', fxAnim: 'none', fxOp: 0 },
    { k: 'esc', name: 'Escarchados', short: 'escarchado', form: 'Escarchado', tint: '#FBE9F0', title: 'Con brillo escarchado', desc: 'Esmalte con glitter que destella con la luz. Ideal para fondos, cabellos y detalles que quieres que llamen la atención.', tags: ['Glitter', 'Destellos', 'Colores vivos'], imgs: [1, 2, 3, 4], anim: 'pzCut 6s ease-in-out infinite', fx: 'radial-gradient(circle at 20% 30%,#fff 0 1.5px,transparent 2px),radial-gradient(circle at 70% 20%,#fff 0 1.5px,transparent 2px),radial-gradient(circle at 40% 70%,#fff 0 1.5px,transparent 2px),radial-gradient(circle at 80% 65%,#fff 0 1.5px,transparent 2px),radial-gradient(circle at 55% 45%,#fff 0 1px,transparent 1.5px)', fxAnim: 'pzGlit 1.6s ease-in-out infinite', fxOp: 1 },
    { k: 'arena', name: 'Arena movediza', short: 'arena movediza', form: 'Arena movediza', tint: '#FDF0D2', title: 'Arena que se mueve', desc: 'Una cápsula con líquido y escarcha que fluye cada vez que mueves el pin. El detalle que todos quieren tocar.', tags: ['Líquido interior', 'Escarcha flotante', 'Efecto 3D'], imgs: [1], anim: 'pzSand 3.4s ease-in-out infinite', fx: 'none', fxAnim: 'none', fxOp: 0 },
    { k: 'mov', name: 'Con movimiento', short: 'movimiento', form: 'Con movimiento', tint: '#EEE8FC', title: 'Pines que se mueven', desc: 'Piezas que giran, se deslizan, cuelgan o se abren. Un pin interactivo que cuenta más de tu marca.', tags: ['Deslizables', 'Giratorios', 'Colgantes', 'Que se abren'], imgs: [1, 2, 3, 4], anim: 'pzSwing 2.6s ease-in-out infinite', fx: 'none', fxAnim: 'none', fxOp: 0 }
  ];
  var tipo = 'espejo', tipoImg = 1;
  var view = q('[data-dp-pz-view]'), viewIn = q('[data-dp-pz-viewin]'), hero = q('[data-dp-pz-hero]'), fxEl = q('[data-dp-pz-fx]');
  var zhint = q('[data-dp-pz-zhint]');
  var acabado = q('[data-dp-pz-acabado]');

  function renderTipo() {
    var cur = T.filter(function (t) { return t.k === tipo; })[0] || T[0];
    var hi = cur.imgs.indexOf(tipoImg) > -1 ? tipoImg : 1;
    qa('[data-dp-pz-tabs] button').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-k') === cur.k); });
    view.style.background = cur.tint;
    viewIn.style.animation = cur.anim;
    hero.src = IM[cur.k + '-' + hi] || hero.src; hero.alt = cur.name;
    fxEl.style.background = cur.fx; fxEl.style.backgroundSize = '250% 250%';
    fxEl.style.animation = cur.fxAnim; fxEl.style.opacity = cur.fxOp;
    q('[data-dp-pz-tag]').textContent = cur.name;
    q('[data-dp-pz-title]').textContent = cur.title;
    q('[data-dp-pz-desc]').textContent = cur.desc;
    var tags = q('[data-dp-pz-tags]'); tags.textContent = '';
    cur.tags.forEach(function (t) { tags.appendChild(el('span', '', t)); });
    var th = q('[data-dp-pz-thumbs]'); th.textContent = '';
    if (cur.imgs.length > 1) {
      cur.imgs.forEach(function (n) {
        var b = el('button'); b.type = 'button'; b.style.background = cur.tint; b.setAttribute('aria-label', cur.name + ' ' + n);
        if (n === hi) b.classList.add('is-on');
        var i = el('img'); i.src = IM[cur.k + '-' + n]; i.alt = ''; i.width = 120; i.height = 120; b.appendChild(i);
        b.addEventListener('click', function () { tipoImg = n; renderTipo(); });
        th.appendChild(b);
      });
    }
    q('[data-dp-pz-quote]').textContent = 'Cotizar con ' + cur.short + ' →';
    return cur;
  }
  qa('[data-dp-pz-tabs] button').forEach(function (b) {
    b.addEventListener('click', function () { tipo = b.getAttribute('data-k'); tipoImg = 1; zoomOut(); renderTipo(); });
  });
  q('[data-dp-pz-quote]').addEventListener('click', function () {
    var cur = T.filter(function (t) { return t.k === tipo; })[0];
    if (acabado && cur) acabado.value = cur.form;
  });

  /* zoom al pasar el cursor */
  function zoomOut() { hero.style.transform = 'scale(1)'; hero.style.transformOrigin = '50% 50%'; if (zhint) zhint.style.opacity = 1; }
  view.addEventListener('mousemove', function (e) {
    var r = view.getBoundingClientRect();
    var x = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
    var y = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
    hero.style.transformOrigin = x + '% ' + y + '%'; hero.style.transform = 'scale(2.2)';
    if (zhint) zhint.style.opacity = 0;
  });
  view.addEventListener('mouseleave', zoomOut);

  /* ---------- combina acabados ---------- */
  var B = {
    troq: { name: 'Troquel normal', img: 'troqb-2', tint: '#E4F6F0' },
    espejo: { name: 'Efecto espejo', img: 'espejo-3', tint: '#EEF1F5' }
  };
  var F = {
    esc: { name: 'Escarcha', img: 'esc-2', tint: '#FBE9F0', d: 'con zonas de glitter que destellan con la luz' },
    arena: { name: 'Arena movediza', img: 'arena-1', tint: '#FDF0D2', d: 'con una cápsula de arena movediza que fluye al moverlo' },
    mov: { name: 'Movimiento', img: 'mov-1', tint: '#EEE8FC', d: 'con piezas que giran, se deslizan o cuelgan' }
  };
  var cbB = 'troq', cbF = 'esc';
  function renderCb() {
    var b = B[cbB], f = F[cbF];
    qa('[data-dp-pz-base]').forEach(function (n) { n.classList.toggle('is-on', n.getAttribute('data-dp-pz-base') === cbB); });
    qa('[data-dp-pz-fxo]').forEach(function (n) { n.classList.toggle('is-on', n.getAttribute('data-dp-pz-fxo') === cbF); });
    var mb = q('[data-dp-pz-mixb]'), mf = q('[data-dp-pz-mixf]');
    mb.style.background = b.tint; mb.querySelector('img').src = IM[b.img];
    mf.style.background = f.tint; mf.querySelector('img').src = IM[f.img];
    q('[data-dp-pz-cbname]').textContent = b.name + ' + ' + f.name;
    q('[data-dp-pz-cbdesc]').textContent = 'Un pin ' + (cbB === 'espejo' ? 'con zonas de metal espejo' : 'troquelado a la forma de tu diseño') + ', ' + f.d + '.';
  }
  qa('[data-dp-pz-base]').forEach(function (n) { n.addEventListener('click', function () { cbB = n.getAttribute('data-dp-pz-base'); renderCb(); }); });
  qa('[data-dp-pz-fxo]').forEach(function (n) { n.addEventListener('click', function () { cbF = n.getAttribute('data-dp-pz-fxo'); renderCb(); }); });
  q('[data-dp-pz-cbquote]').addEventListener('click', function () {
    if (acabado) acabado.value = B[cbB].name + ' + ' + F[cbF].name;
  });

  renderTipo();
  renderCb();

  /* ---------- formulario de cotización (formulario de contacto de Shopify) ---------- */
  var form = q('#dp-pz-form');
  if (!form) return;
  var wrap = q('[data-dp-pz-formwrap]'), sent = q('[data-dp-pz-sent]'), go = q('[data-dp-pz-go]');

  function showSent(name, mail, qty) {
    var first = (name || '').trim().split(/\s+/)[0];
    q('[data-dp-pz-name]').textContent = first ? ', ' + first : '';
    if (mail) q('[data-dp-pz-mail]').textContent = mail;
    var msg = 'Hola Dollpins, soy ' + (name || '') + '. Acabo de pedir una cotización' + (qty ? ' de ' + qty + ' pines' : '') + ' y les envío mi logo.';
    q('[data-dp-pz-walogo]').href = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(msg);
    wrap.hidden = true; sent.hidden = false;
    var card = q('#dp-pz-formcard');
    if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  form.addEventListener('submit', function (e) {
    if (!window.fetch || !window.FormData) return;           // sin JS moderno: envío normal de Shopify
    e.preventDefault();
    if (!form.reportValidity()) return;
    var fd = new FormData(form);
    if (!String(fd.get('contact[body]') || '').trim()) fd.set('contact[body]', 'Sin descripción adicional.');
    var name = String(fd.get('contact[name]') || ''), mail = String(fd.get('contact[email]') || ''), qty = String(fd.get('contact[Cantidad]') || '');
    var label = go.textContent;
    go.disabled = true; go.textContent = 'Enviando…';
    var old = q('.dp-pz-form__err'); if (old) old.remove();
    fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        var u = r.url || '';
        if (u.indexOf('/challenge') > -1) { form.submit(); return; }   // Shopify pide el captcha: se envía de forma normal
        if (!r.ok) throw new Error('no enviado');
        if (u.indexOf('contact_posted=true') > -1) { showSent(name, mail, qty); return; }
        return r.text().then(function (html) {
          // Shopify vuelve a pintar la página: si el aviso de «enviado» viene visible, se envió; si trae el error, no.
          if (/data-dp-pz-sent>/.test(html)) { showSent(name, mail, qty); return; }
          throw new Error('no enviado');
        });
      })
      .catch(function () {
        var err = el('div', 'dp-pz-form__err', 'No pudimos enviar tu solicitud. Revisa los datos o escríbenos por WhatsApp.');
        err.setAttribute('role', 'alert');
        wrap.insertBefore(err, wrap.querySelector('.dp-pz-form__grid'));
      })
      .then(function () { go.disabled = false; go.textContent = label; });
  });
})();
